import React, {useEffect} from "react";
import {useNavigate} from "react-router-dom";
import {App2} from "../App2";
import {useProfile} from "../../UserProfileProvider";
import {useAuth0} from "@auth0/auth0-react";
import './HomePage.css'
import {JoinKensu} from "./JoinKensu";
import {HomePage} from "./HomePage";

/**
 * The home page right now is only for logged in users, since it's only visible
 * to alpha participants (and thus logged in users). Eventually it's gonna have to
 * switch to handler both logged in and not-logged in users.
 */
export const Home = () => {

  const {profile, profileError, profileLoading} = useProfile();
  const {user, isLoading} = useAuth0();
  const navigate = useNavigate();

  useEffect(() => {
    
    // Shouldn't be here if no user.
    if (!user && !isLoading) {
      navigate('/');
    }
    
  }, [user, isLoading]);
  
  return <App2>
    <div className={'AppSection BeigeSection'}>
      <div className={'AppSectionContent WelcomeSection'}>

        {profileLoading && <div style={{margin: 50}}>Loading...</div>}

        {profileError && <div className={'ErrorText'} style={{margin: 50}}>Error loading your profile. Please try refreshing the page.</div>}
        
        {!profile && !profileLoading && !profileError && <JoinKensu/>}
        {profile && <HomePage/>}

      </div>
    </div>
  </App2>
}